import { error } from '@ms/yammer-console-logging';

export const getItem = <T>(key: string): T | null => {
  const item = localStorage.getItem(key);

  return item ? (JSON.parse(item) as T) : null;
};

export const setItem = <T>(key: string, item: T): void => {
  try {
    localStorage.setItem(key, JSON.stringify(item));
  } catch (e) {
    error(e);
  }
};

type RemoveItem = (key: string) => void;
export const removeItem: RemoveItem = (key: string) => {
  localStorage.removeItem(key);
};

type Clear = () => void;
export const clear: Clear = () => {
  localStorage.clear();
};
